var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current  text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 24 26",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 0H16V11C15.9987 11.385 15.7775 11.735 15.43 11.9C15.2975 11.9675 15.1487 12.0025 15 12C14.775 11.9987 14.5562 11.9213 14.38 11.78L12 9.88L9.62998 11.78C9.32998 12.0238 8.91622 12.0725 8.56874 11.905C8.22 11.7387 7.99875 11.3862 8 11V6.40869e-06H1C0.447488 6.40869e-06 0 0.447494 0 1.00001V25C0 25.265 0.104998 25.52 0.292499 25.7075C0.48 25.895 0.734995 26 0.999987 26H23C23.265 26 23.52 25.895 23.7075 25.7075C23.895 25.52 24 25.265 24 25V1.00001C24 0.735008 23.895 0.480006 23.7075 0.292518C23.52 0.105018 23.265 1.92261e-05 23 1.92261e-05L23 0Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }